// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".EditorTestArea {\n  display: block;\n  margin: 0;\n  padding: 0;\n  min-width: 100vw;\n  width: 100vw;\n  height: 100vh;\n  min-height: 100vh;\n  overflow: hidden;\n  text-overflow: clip;\n  text-overflow: ellipsis;\n  text-overflow: \"...\";\n}\n\ndiv[id^=colResizer]:hover {\n  /* border-right: 3px solid rgba(150, 150, 150, 255); */\n}\n\ndiv[id^=rowResizer]:hover {\n  /* border-bottom: 3px solid rgba(150, 150, 150, 255); */\n}", ""]);
// Exports
module.exports = exports;
